import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { useCallback } from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import Button from '@atlaskit/button/standard-button';
import { EVENT_CHANNEL } from '../../../../analytics';
import { DatasourceDisplay, DatasourceSearchMethod } from '../../../../analytics/types';
import { buildDatasourceAdf } from '../../../../common/utils/adf';
import { useUserInteractions } from '../../../../contexts/user-interactions';
import { useDatasourceContext } from '../datasource-context';
import { useViewModeContext } from '../mode-switcher/useViewModeContext';
export var InsertButton = function InsertButton(_ref) {
  var testId = _ref.testId,
    url = _ref.url,
    getAnalyticsPayload = _ref.getAnalyticsPayload,
    children = _ref.children;
  var _useDatasourceContext = useDatasourceContext(),
    datasourceId = _useDatasourceContext.datasourceId,
    parameters = _useDatasourceContext.parameters,
    _useDatasourceContext2 = _useDatasourceContext.tableState,
    status = _useDatasourceContext2.status,
    totalCount = _useDatasourceContext2.totalCount,
    isValidParameters = _useDatasourceContext.isValidParameters,
    visibleColumnCount = _useDatasourceContext.visibleColumnCount,
    visibleColumnKeys = _useDatasourceContext.visibleColumnKeys,
    columnCustomSizes = _useDatasourceContext.columnCustomSizes,
    wrappedColumnKeys = _useDatasourceContext.wrappedColumnKeys,
    onInsert = _useDatasourceContext.onInsert;
  var userInteractions = useUserInteractions();
  var _useViewModeContext = useViewModeContext(),
    currentViewMode = _useViewModeContext.currentViewMode;
  var isInsertDisabled = !isValidParameters(parameters) || status === 'rejected' || status === 'unauthorized' || status === 'loading';
  var onInsertPressed = useCallback(function (e, analyticsEvent) {
    var _insertButtonClickedE;
    if (!parameters || !isValidParameters(parameters) || !url) {
      return;
    }
    var insertButtonClickedEvent = analyticsEvent.update({
      actionSubjectId: 'insert',
      attributes: _objectSpread({
        totalItemCount: totalCount || 0,
        displayedColumnCount: visibleColumnCount.current,
        display: currentViewMode === 'inline' ? DatasourceDisplay.DATASOURCE_INLINE : DatasourceDisplay.DATASOURCE_TABLE,
        searchMethod: DatasourceSearchMethod.DATASOURCE_SEARCH_QUERY,
        actions: userInteractions.get()
      }, getAnalyticsPayload()),
      eventType: 'ui'
    });
    var consumerEvent = (_insertButtonClickedE = insertButtonClickedEvent.clone()) !== null && _insertButtonClickedE !== void 0 ? _insertButtonClickedE : undefined;
    insertButtonClickedEvent.fire(EVENT_CHANNEL);
    if (currentViewMode === 'inline') {
      onInsert({
        type: 'inlineCard',
        attrs: {
          url: url
        }
      }, consumerEvent);
    } else {
      onInsert(buildDatasourceAdf({
        id: datasourceId,
        parameters: parameters,
        views: [{
          type: 'table',
          properties: {
            columns: (visibleColumnKeys || []).map(function (key) {
              var width = columnCustomSizes === null || columnCustomSizes === void 0 ? void 0 : columnCustomSizes[key];
              var isWrapped = wrappedColumnKeys === null || wrappedColumnKeys === void 0 ? void 0 : wrappedColumnKeys.includes(key);
              return _objectSpread(_objectSpread({
                key: key
              }, width ? {
                width: width
              } : {}), isWrapped ? {
                isWrapped: isWrapped
              } : {});
            })
          }
        }]
      }, url), consumerEvent);
    }
  }, [columnCustomSizes, currentViewMode, datasourceId, getAnalyticsPayload, isValidParameters, onInsert, parameters, totalCount, url, userInteractions, visibleColumnCount, visibleColumnKeys, wrappedColumnKeys]);
  return jsx(Button, {
    appearance: "primary",
    onClick: onInsertPressed,
    isDisabled: isInsertDisabled,
    testId: testId
  }, children);
};